import React, { } from 'react'
import { Form, InputNumber, Select } from 'antd'

function FootprintSetting (props) {
  const { defPlaceholder, defConfig, schema, sortOptions } = props

  return (
    <>
      <Form.Item {...defConfig('timeline', 'select')}>
        <Select showSearch placeholder={defPlaceholder('timeline', 'select')} options={schema} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('column', 'select')}>
        <Select showSearch placeholder={defPlaceholder('column', 'select')} options={schema} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('order', 'select')}>
        <Select showSearch placeholder={defPlaceholder('order', 'select')} options={sortOptions} optionFilterProp="children" />
      </Form.Item>
      <Form.Item {...defConfig('limit', 'input', false)}>
        <InputNumber placeholder={defPlaceholder('limit', 'input')} precision={0} min={0} style={{ width: '100%' }} />
      </Form.Item>
    </>
  )
}

export default FootprintSetting
